<template>
<div class="sensitive_header">
        <div class="title">{{$t("敏感内容文档#!!!#src/pages/H5/Cloud/components/header/sensitiveBlockedHeader.vue_1")}}</div>
        <slot name="avatar"></slot>
    </div>
</template>

<script>
export default {
    name: 'sensitiveBlockedHeader',
    props: {},
    emits: [],
    components: {

    },
    data() {
        return {

        }
    },
    computed: {

    },
    methods: {
        
    },
}
</script>

<style lang="scss" scoped>
.sensitive_header {
    height: 54px;
    padding: 0px 16px;
    width: calc(100% - 32px);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-shadow: inset 0 -1px 0 0 #e2e6ed;

    .title {
        height: 20px;
        line-height: 20px;
        font-weight: 500;
        font-size: 14px;
        color: #121317;
    }
}
</style>
